import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipGrid } from '@angular/material/chips';
import { Lookup } from '../../models/lookup';

@Component({
  selector: 'app-tree-field',
  templateUrl: './tree-field.component.html',
  standalone: false
})
export class TreeFieldComponent {
  @Input() required = false;
  @Input() isSubmitted = false;
  @Input() recordsLoading = false;
  @Input() isDisabled = false;
  @Input() isFilter = false;
  @Input() labelField: string = '';
  @Input() recordsTree: any[] = [];
  @Input() detailsSelectedRecords: any;
  @Input() stopAutoParentSelection!: boolean;
  @Output() selected = new EventEmitter();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  addOnBlur = false;
  selectable = true;
  removable = true;
  searchCtrl = new FormControl();
  selectedRecords: Lookup[] = [];
  showRecordsTree = false;
  removeItem!: any;

  // recordsLoading = false;
  @ViewChild('chipRecordsList', { static: false }) chipRecordsList!: MatChipGrid;
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef<HTMLInputElement>;
  @ViewChild('treeDropdown', { static: false }) treeDropdown!: ElementRef<HTMLElement>;

  constructor(private eRef: ElementRef) { }

  updateSelectedRecords(data: any) {
    this.detailsSelectedRecords = [];
    this.selectedRecords = [];
    if (data) {
      data.forEach((element: Lookup) => {
        if ((!element.child || this.stopAutoParentSelection) && !this.isInArray(this.selectedRecords, element)) {
          this.selectedRecords.push(element);
        }
      });
      this.selected.emit(this.selectedRecords);
      /* this.searchInput.nativeElement.value = '';
      this.searchCtrl.setValue(null);
      this.filterTree(''); */
    }
  }

  isInArray(parentObj: any, item: any) {
    return parentObj.some((obj: any) => obj.id === item.id);
  }

  // dropdowns overlay events
  @HostListener('window:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.showRecordsTree = false;
    }
  }
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!event) {
      this.showRecordsTree = !this.showRecordsTree;
    } else if (!this.eRef.nativeElement.contains(event.target)) {
      this.showRecordsTree = false;
    }
    if (!this.showRecordsTree) {
      this.searchCtrl.setValue(null);
      this.filterTree('');
    } else if ((!event || !this.treeDropdown.nativeElement.contains(event.target)) && !this.isFilter) {
      this.searchInput.nativeElement.focus();
      // this.treeDropdown.nativeElement.scrollTo({ top: 0 });
      setTimeout(() => { this.treeDropdown.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' }) }, 1);
      ;
    }
  }

  filterTree(value: string, event = false) {
    if (event) { this.showRecordsTree = true; }
  }

  removeRecord(node: any) {
    this.removeItem = node
    setTimeout(() => {
      this.removeItem = null
    }, 100);
  }

}
